import { useEffect, useState } from "react";
import { message } from "antd";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { syncProjectData } from "../redux/project/action";
import api from "./api";

const useSyncProjectData = (id: string, laborRatesScreen?: boolean) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const dispatch = useDispatch();
  const { adminDefaults } = useSelector(
    (state: RootStateOrAny) => state.offlineData
  );
  const { online, outbox } = useSelector(
    (state: RootStateOrAny) => state.offline
  );

  useEffect(() => {
    if (online) {
      fetchdata();
    }
  }, [laborRatesScreen ? outbox.length : null]);

  const fetchdata = async () => {
    if (!id || outbox.length !== 0) {
      return;
    }

    const url = `jobs/${id}/${
      Object.keys(adminDefaults).length > 0 ? "false" : "true"
    }`;

    setIsLoading(true);
    try {
      const res = await api.get(url);
      dispatch(syncProjectData(res));
    } catch (error) {
      message.error("Could not refresh project data. Using saved project data if available.");
      console.error("Project data sync failed", error);
    } finally {
      setIsLoading(false);
    }
  };

  return [isLoading];
};

export default useSyncProjectData;
